import styled from '@emotion/styled'
import { css } from '@emotion/react'
import tw from 'twin.macro'
import { Chevron, Heading } from '@pretamanger/component-library'

const variants = {
  base: css`
    &[data-expanded='true'] {
      ${tw`bg-grey-100`}
    }
    [aria-expanded='true'] {
      ${tw`text-pretRed-700`}
      > svg {
        ${tw`-rotate-90`}
      }
    }
  `
}

export const CollapsibleItem = styled.div`
  ${props => variants[props.variant || 'base']}
`

export const CollapsibleHeading = styled(Heading)`
  ${tw`font-normal leading-none`}
`

export const CollapsibleButton = styled.button`
  ${tw`flex w-full justify-between`}
`

export const ToggleIcon = styled(Chevron)`
  ${tw`relative transform rotate-90 translate-y-1 ml-2`}
`
